import {Component} from '@angular/core';
import {CreditCardType} from "../../../models/creditCardType.enum";
import {CreditCard} from "../../../models/creditCard";
import {MASTER_CARD_ICON_PATH, VISA_ICON_PATH} from "../../../constants/payment.constant";
import {AuthService} from "../../../services/auth.service";

@Component({
  selector: 'app-profile-payment-method',
  templateUrl: './profile-payment-method.component.html',
  styleUrls: ['./profile-payment-method.component.css']
})
export class ProfilePaymentMethodComponent {

  protected readonly currentUserId: string | null;

  constructor(
    private readonly authService: AuthService
  ) {
    this.currentUserId = this.authService.getCurrentUserId();
  }

  // fixme: remove when there will be real data
  protected paymentMethods: Array<CreditCard> = [
    {
      id: 'someUUID1',
      cardNumber: '**** **** **** 0000',
      type: CreditCardType.VISA,
      active: false,
      fullName: 'John Doe',
    },
    {
      id: 'someUUID2',
      cardNumber: '**** **** **** 0000',
      type: CreditCardType.MASTER_CARD,
      active: true,
      fullName: 'John Doe',
    }
  ];

  protected updateCreditCardStatus(method: CreditCard) {
    this.unselectAllCreditCard();
    method.active = true;
    // todo: send request to API. replace code block above to "next" block, or rollback if error appeared
  }

  protected getIconByCreditCardType(method: CreditCard) {
    return method.type == CreditCardType.VISA ?
      VISA_ICON_PATH : MASTER_CARD_ICON_PATH
  }

  protected transformTypeAsLabel(method: CreditCard) {
    return method.type.replace('_', ' ');
  }

  protected deletePaymentMethod(method: CreditCard) {
    if (method.active) return;
    // todo: send request to API, and replace this filter to "next" block of subscription
    this.paymentMethods = this.paymentMethods.filter(paymentMethod => paymentMethod.id != method.id);
  }

  private unselectAllCreditCard() {
    this.paymentMethods.forEach(creditCard => creditCard.active = false);
  }
}
